import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { ColumnMode, DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '@core/services/language.service';
import { ToastrService } from 'ngx-toastr';
// import { LanguageService } from '@core/services/language.service';

@Component({
  selector: 'app-z-social-links',
  templateUrl: './z-social-links.component.html',
  styleUrls: ['./z-social-links.component.scss'],
          encapsulation: ViewEncapsulation.None
  
})
export class ZSocialLinksComponent implements OnInit {
  public arrCoupons: any[] = [];
   public currentLang : string


//   public arrCoupons: any[] = [
//   { 
//     id: 1,
//     code: 'PRAYER-001',
//     is_valid: true,
//     expires_at: new Date('2026-02-15')
//   },
//   {
//     id: 2,
//     code: 'PRAYER-002',
//     is_valid: false,
//     expires_at: new Date('2025-11-01')
//   },
//   {
//     id: 3,
//     code: 'PRAYER-003',
//     is_valid: true,
//     expires_at: new Date('2026-05-20')
//   },
//   {
//     id: 4,
//     code: 'PRAYER-004',
//     is_valid: false,
//     expires_at: new Date('2024-12-30')
//   },
//   {
//     id: 5,
//     code: 'PRAYER-005',
//     is_valid: true,
//     expires_at: new Date('2026-08-10')
//   }
// ];

  constructor( 
    private apisService: ApisService,
    // private loadingService: Loadingscr,
    private router: Router,
        private language : LanguageService,
          private toastr : ToastrService
                        ,public _translateService: TranslateService
  ) {} 
  public lang : any

  public currentPage = 1;  
  public itemsPerPage = 10;
  public totalItems = 0;
  public ColumnMode = ColumnMode;
  public SelectionType = SelectionType;

 
  public levels: any[] = [];
  public tempData = [];

  @ViewChild(DatatableComponent) table: DatatableComponent;

   

  // ngOnInit(): void {
  //   this.getLevels();

  // }
  ngOnInit(): void {

    
                        this.currentLang = localStorage.getItem('currentLang')

  

    this.language.currentLang.subscribe((res: string) => {
this.lang = res; 
});

    this.apisService.socialLinks().subscribe({ 
      next:(response:any)=> { 
        this.arrCoupons = response.data || [] ;
        console.log('response is' , this.arrCoupons)
      }, 
      error:(err)=> { 
        console.log('error in fetching', err)
      }
    })
  }
 


  getLevels() {
    this.apisService.socialLinks().subscribe({
      next: (response) => {
        this.arrCoupons = response.data || [] ;
        console.log(this.levels);
      },
    });
  }

 

  addCoupon() {
    this.router.navigate(["main/coupons/add-coupon"]);
  }

  

 

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.arrCoupons = this.tempData.filter((d) =>
      d.code.toLowerCase().includes(val)
    );
    this.table.offset = 0;
  }


     confirmDelete(id:any){ 
  this.apisService.DeleteSocialLinks(id).subscribe({
  next: (response: any) => {
  this.toastr.success(
    this.currentLang === 'ar'
      ? 'تم الحذف بنجاح'
      : 'Deleted successfully'
  );

  this.getLevels();
},

error: (error: any) => {
  console.error(error);

  this.toastr.error(
    this.currentLang === 'ar'
      ? 'حدث خطأ ما'
      : 'Something went wrong'
  );
}

  }
)}
}
